import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errText } from "@/lib/http";
import { AuthShell, Field, PrimaryBtn, ErrorNote } from "@/components/mh/AuthShell";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/");
    } catch (e2) {
      setErr(errText(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell testId="login-page" eyebrow="Sign in" title={<>Welcome back to <em>the house.</em></>}
      footer={<div className="space-y-2"><div>No workspace yet? <Link to="/request-access" className="text-foreground underline underline-offset-4" data-testid="request-access-link">Request one</Link> or <Link to="/audit" className="text-foreground underline underline-offset-4" data-testid="public-audit-link">take the free audit</Link>.</div></div>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} testId="login-email" autoComplete="email" />
        <Field label="Password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} testId="login-password" autoComplete="current-password" />
        <ErrorNote>{err}</ErrorNote>
        <PrimaryBtn type="submit" disabled={busy} testId="login-submit">{busy ? "Signing in…" : "Sign in"}</PrimaryBtn>
        <Link to="/forgot-password" className="block text-center font-mono text-xs text-muted-foreground hover:text-foreground" data-testid="forgot-link">Forgot password?</Link>
      </form>
    </AuthShell>
  );
}
